import { render } from "./barcode_component.vue?vue&type=template&id=172e74fa&scoped=true"
import script from "./barcode_component.vue?vue&type=script&lang=js"
export * from "./barcode_component.vue?vue&type=script&lang=js"

import "./barcode_component.vue?vue&type=style&index=0&id=172e74fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172e74fa"]])

export default __exports__